<footer><span>{{version}}</span></footer>